const index = () => import('./Index');

//2019年省级工业转型升级专项资金
export default {
  routes: [
    {
      path: '/server/v2021/index',
      name: 'server_v2021_index',
      component: index,
      meta:{public:true}
    }
  ]
}



// WEBPACK FOOTER //
// ./src/components/special/server/v2021/router.js